import { html } from 'lit-element';
import { CustomLitElement } from '../CustomLitElement.js';
import { aggregateStyles } from '../cssUtils.js';

/**
 * @element multiple-choice-cell
 * @prop {Object} model - The model for the pie
 * @prop {Object} aggregate - The aggregate
 */
export class MultipleChoiceAggregate extends CustomLitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      aggregate: { type: Array, attribute: false },
    };
  }

  _renderResponses() {
    const { responses, incorrect, averageScore, partiallyCorrect, correct } =
      this.aggregate || {};

    return html`
      <span>Responses: ${responses}</span><br />
      <span>Average Score: ${averageScore ? averageScore.toFixed(2) : 0}</span
      ><br />
      <span>Correct: ${correct}</span><br />
      <span>Partially Correct: ${partiallyCorrect}</span><br />
      <span>Incorrect: ${incorrect}</span><br />
      <br />
    `;
  }

  _renderSelections() {
    const { selections } = this.aggregate || {};

    if (!selections) return html``;

    return Object.values(selections).map(selection => {
      const { value, count } = selection;

      return html`
        <span>
          Choice "${value}" was selected ${count} time${count > 1 ? 's' : ''}. </span
        ><br />
      `;
    });
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html` <style>
        ${aggregateStyles}
      </style>
      <div class="aggregate">
        ${this._renderResponses()} ${this._renderSelections()}
      </div>`;
  }
}

export default MultipleChoiceAggregate;
